import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';
import Products from './pages/Products';
import Projects from './pages/Projects';
import Blogs from './pages/Blogs';
import ContactUs from './pages/ContactUs';
import FreeQuote from './pages/FreeQuote';
import ScrollToTop from './components/ScrollToTop';
import FloatingSocialMenu from './components/FloatingSocialMenu';
import SolarPreventiveMaintaince from './components/SolarPreventiveMaintaince';
import PvInstallation from './components/PvInstallation';
import BirdProofing from './components/BirdProofing';
import Warranty from './components/Warranty';
import HealthReport from './components/HealthReport';
import SystemRepair from './components/SystemRepair';
import Consultation from './components/Consultation';
import PvProtectionCoatings from './components/PvProtectionCoatings';
import SolaCleaningChemicals from './pages/SolaCleaningChemicals';
import BuyProductPage from './pages/BuyProductPage';
import BuyChemiTekPage from './pages/BuyChemiTekPage';
import { Analytics } from '@vercel/analytics/react';
import Schema from './components/Schema';
import News from './pages/News';

function App() {
  return (
    <Router>
    <Analytics />
    <Schema />
      <div
        className="flex flex-col min-h-screen bg-fixed bg-cover bg-no-repeat bg-gray-100"
      >
        <Navbar />
        <main className="flex-grow bg-white bg-opacity-40 backdrop-blur-sm">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products" element={<Products />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/free-quote" element={<FreeQuote />} />
            <Route path="/solar-preventive-maintaince" element={<SolarPreventiveMaintaince />} />
            <Route path="/pv-installation" element={<PvInstallation />} />
            <Route path="/bird-proofing" element={<BirdProofing />} />
            <Route path="/warranty" element={<Warranty />} />
            <Route path="/health-report" element={<HealthReport />} />
            <Route path="/system-repair" element={<SystemRepair />} />
            <Route path="/consultation" element={<Consultation />} />
            <Route path="/pv-protection-coatings" element={<PvProtectionCoatings />} />
            <Route path="/sola-cleaning-chemicals" element={<SolaCleaningChemicals />} />
            <Route path="/buy/:productId" element={<BuyProductPage />} />
            <Route path="/buy-chemi-tek" element={<BuyChemiTekPage />} />
            <Route path="/news" element={<News />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <FloatingSocialMenu />
      
    </Router>
  );
}

export default App;
